import { isNil } from 'ramda';
import { createSelector } from 'reselect';

import type { IShareFieldRealtorsAndAgencies } from '../../types/redux/shareRealtorsAndAgencies';
import { getCurrentTabState } from '../tabs';

export const getPagination = createSelector(getCurrentTabState, tabState => {
  const { page, limit, total } = (tabState as IShareFieldRealtorsAndAgencies).listing;

  if (!isNil(total) && !isNil(limit) && !isNil(page)) {
    return { page, limit, total };
  }

  return null;
});
